<template>
    <div class="p-grid">
        <div class="p-col-12">
            <div class="card p-shadow-1">
                <h5>Gerenciamento de relógios e tarefas</h5>
                <hr>

                <div class="p-fluid p-formgrid p-grid">
                    <div class="p-field p-col-12 p-md-5">
                        <label>Buscar CNPJ</label>
                        <div class="p-inputgroup">
                            <InputText v-model="valorBusca" placeholder="Razão social ou CNPJ" @keyup.enter="buscarCnpjs" />
                            <Button icon="pi pi-search" title="Buscar CNPJ" @click="buscarCnpjs" />
                        </div>
                    </div>
                </div>

                <DataTable :value="empresas" :loading="carregandoCnpjs" selectionMode="single" :selection.sync="empresaSelecionada"
                    dataKey="id" class="p-datatable-sm p-datatable-striped" @row-select="selecionarEmpresa">
                    <Column field="id" header="ID"></Column>
                    <Column field="razaoSocial" header="Razão social"></Column>
                    <Column field="cnpj" header="CNPJ">
                        <template #body="slotProps">
                            {{ (slotProps.data.cnpj || slotProps.data.numero) | maskCNPJ }}
                        </template>
                    </Column>
                </DataTable>
                <Paginator :rows="totalPorPagina" :totalRecords="totalEmpresas" :rowsPerPageOptions="[15, 25, 30]"
                    template="FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                    currentPageReportTemplate="Listando {first} a {last} de {totalRecords}" @page="paginarCnpjs" />

                <Message v-if="erroRelacionados" severity="error" :closable="false" class="p-mt-3">{{ erroRelacionados }}</Message>
                <div v-if="!empresaSelecionada" class="p-mt-3 p-text-center">
                    Selecione um CNPJ para consultar os relógios e as tarefas.
                </div>

                <template v-else>
                    <Toolbar class="p-mt-4 p-mb-3">
                        <template slot="left">
                            <strong>{{ nomeEmpresaSelecionada }}</strong>
                        </template>
                        <template slot="right">
                            <Button label="Atualizar" icon="pi pi-refresh" class="p-mr-2" @click="carregarRelacionados" :disabled="operacaoEmAndamento" />
                            <Button label="Limpar tarefas" icon="pi pi-trash" class="p-button-danger" @click="abrirConfirmacaoLimpar"
                                :disabled="!tarefas.length || operacaoEmAndamento" />
                        </template>
                    </Toolbar>

                    <Panel header="Tarefas">
                        <DataTable :value="tarefas" :loading="carregandoTarefas" :paginator="true" :rows="10"
                            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink RowsPerPageDropdown"
                            :rowsPerPageOptions="[10,15,20]" currentPageReportTemplate="Listando {first} a {last} de {totalRecords}"
                            class="p-datatable-sm p-datatable-striped">
                            <Column field="id" header="ID" />
                            <Column field="tipo" header="Tipo" />
                            <Column field="idRelogio" header="ID do relógio" />
                            <Column field="numeroSerie" header="Número de série" />
                            <Column header="Ações" style="width: 6rem; text-align: center">
                                <template #body="slotProps">
                                    <Button icon="pi pi-trash" title="Excluir tarefa" class="p-button-rounded p-button-danger"
                                        @click="abrirConfirmacaoExcluir(slotProps.data)" :loading="tarefaExcluindoId === slotProps.data.id"
                                        :disabled="operacaoEmAndamento" />
                                </template>
                            </Column>
                        </DataTable>
                        <div v-if="!carregandoTarefas && !tarefas.length" class="p-p-3 p-text-center">Nenhuma tarefa relacionada a este CNPJ.</div>
                    </Panel>
                </template>

                <Dialog :visible.sync="exibirConfirmacao" header="Confirmar exclusão" :modal="true" :style="{width: '450px'}">
                    <div class="confirmation-content">
                        <i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem; color:red" />
                        <span v-if="tarefaSelecionada">Excluir a tarefa <b>#{{ tarefaSelecionada.id }}</b>?</span>
                        <span v-else>Excluir todas as tarefas do CNPJ selecionado?</span>
                    </div>
                    <template #footer>
                        <Button label="Não" icon="pi pi-times" class="p-button-secondary" @click="exibirConfirmacao = false" :disabled="operacaoEmAndamento" />
                        <Button label="Sim" icon="pi pi-check" class="p-button-danger" @click="confirmarExclusao" :loading="operacaoEmAndamento" />
                    </template>
                </Dialog>
            </div>
        </div>
    </div>
</template>

<script>
import EmpresaService from '@/service/EmpresaService';
import GerenciamentoRelogiosTarefasService from '@/service/GerenciamentoRelogiosTarefasService';
import { exibirMensagem, exibirMensagemSis } from '@/global';

export default {
    data() {
        return {
            empresaService: null,
            gerenciamentoService: null,
            empresas: [],
            empresaSelecionada: null,
            tarefas: [],
            valorBusca: '',
            pagina: 0,
            totalPorPagina: 15,
            totalEmpresas: 0,
            carregandoCnpjs: false,
            carregandoTarefas: false,
            erroRelacionados: '',
            exibirConfirmacao: false,
            tarefaSelecionada: null,
            tarefaExcluindoId: null,
            tipoExclusao: null
        };
    },
    computed: {
        operacaoEmAndamento() {
            return this.tarefaExcluindoId !== null || this.tipoExclusao === 'todos';
        },
        nomeEmpresaSelecionada() {
            return this.valor(this.empresaSelecionada, ['razaoSocial', 'nome', 'cnpj', 'numero']);
        }
    },
    methods: {
        listarCnpjs() {
            this.carregandoCnpjs = true;
            this.empresaService.listarCnpj(this.valorBusca.replace(/[.\-/]/g, ''), this.pagina, this.totalPorPagina)
                .then(resp => {
                    this.totalEmpresas = resp.data.totalItens || 0;
                    this.empresas = resp.data.empresas || [];
                })
                .catch(erro => exibirMensagem(this, erro))
                .finally(() => { this.carregandoCnpjs = false; });
        },
        buscarCnpjs() {
            this.pagina = 0;
            this.totalEmpresas = 0;
            this.empresaSelecionada = null;
            this.tarefas = [];
            this.listarCnpjs();
        },
        paginarCnpjs(event) {
            this.pagina = event.page;
            this.totalPorPagina = event.rows;
            this.listarCnpjs();
        },
        selecionarEmpresa(event) {
            this.empresaSelecionada = event.data;
            this.carregarRelacionados();
        },
        carregarRelacionados() {
            const cnpjId = this.empresaSelecionada && this.empresaSelecionada.id;
            if(!cnpjId) return;
            this.erroRelacionados = '';
            this.tarefas = [];
            this.carregandoTarefas = true;
            this.gerenciamentoService.listarTarefas(cnpjId)
                .then(resp => {
                    this.tarefas = this.listaDaResposta(resp);
                }).catch(erro => {
                    this.erroRelacionados = 'Não foi possível consultar os dados do CNPJ selecionado.';
                    exibirMensagemSis(this, erro.message || 'Erro ao consultar tarefas.', true);
                }).finally(() => {
                    this.carregandoTarefas = false;
                });
        },
        abrirConfirmacaoExcluir(tarefa) {
            if(this.operacaoEmAndamento) return;
            this.tarefaSelecionada = tarefa;
            this.tipoExclusao = 'individual';
            this.exibirConfirmacao = true;
        },
        abrirConfirmacaoLimpar() {
            if(this.operacaoEmAndamento || !this.tarefas.length) return;
            this.tarefaSelecionada = null;
            this.tipoExclusao = 'todos';
            this.exibirConfirmacao = true;
        },
        confirmarExclusao() {
            if(this.tipoExclusao === 'individual') this.excluirTarefa();
            else this.limparTarefas();
        },
        excluirTarefa() {
            const tarefa = this.tarefaSelecionada;
            if(!tarefa || this.tarefaExcluindoId !== null) return;
            this.tarefaExcluindoId = tarefa.id;
            this.gerenciamentoService.excluirTarefa(tarefa.id)
                .then(resp => {
                    this.tarefas = this.tarefas.filter(item => item.id !== tarefa.id);
                    exibirMensagemSis(this, this.mensagemSucesso(resp, 'Tarefa excluída com sucesso.'), false);
                    this.exibirConfirmacao = false;
                })
                .catch(erro => exibirMensagemSis(this, erro.message || 'Erro ao excluir tarefa.', true))
                .finally(() => { this.tarefaExcluindoId = null; });
        },
        limparTarefas() {
            const cnpjId = this.empresaSelecionada && this.empresaSelecionada.id;
            if(!cnpjId || this.tipoExclusao !== 'todos') return;
            this.gerenciamentoService.limparTarefas(cnpjId)
                .then(resp => {
                    this.tarefas = [];
                    exibirMensagemSis(this, this.mensagemSucesso(resp, 'Tarefas limpas com sucesso.'), false);
                    this.exibirConfirmacao = false;
                })
                .catch(erro => exibirMensagemSis(this, erro.message || 'Erro ao limpar tarefas.', true))
                .finally(() => { this.tipoExclusao = null; });
        },
        listaDaResposta(resp) {
            const dados = resp && resp.data;
            if(Array.isArray(dados)) return dados;
            if(dados && Array.isArray(dados.entity)) return dados.entity;
            if(dados && Array.isArray(dados.items)) return dados.items;
            if(dados && Array.isArray(dados.content)) return dados.content;
            return [];
        },
        valor(objeto, campos) {
            if(!objeto) return '';
            for(let i = 0; i < campos.length; i++) {
                if(objeto[campos[i]] !== undefined && objeto[campos[i]] !== null) return objeto[campos[i]];
            }
            return '';
        },
        sincronizando(tarefa) {
            return Boolean(this.valor(tarefa, ['sincronizando', 'synchronizing']));
        },
        mensagemSucesso(resp, padrao) {
            return (resp && resp.data && (resp.data.mensagem || resp.data.message)) || padrao;
        }
    },
    created() {
        this.empresaService = new EmpresaService();
        this.gerenciamentoService = new GerenciamentoRelogiosTarefasService();
        this.listarCnpjs();
    }
};
</script>
